'use strict';

var _ = require('lodash');
var tooltip = _.template(require('../../../common/profile-chart/templates/profile-chart-tooltip-flight-screen.html'));
var AdvancedProfileChartController = function AdvancedProfileChartController($scope, $timeout, chartFormatter, dataProviderService) {
  $scope.chartFormatters = {
    xAxisTickFormatter: chartFormatter.humanReadable,
    yAxisTickFormatter: chartFormatter.humanReadable,
    tooltipFormatter: function tooltipFormatter(curves) {
      return tooltip(dataProviderService.buildTooltip(curves));
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'advanced-profile-chart-tooltip';
  $scope.$watch('visible', function (newValue) {
    if (newValue) {
      $scope.reloadChart();
    }
  });
  $scope.$watch('contextData.selectedMetric.id', function (newValue, oldValue) {
    if (!_.isEqual(newValue, oldValue)) {
      $scope.reloadChart();
    }
  });
  $scope.$watch('contextData.sidebar.visible', function (newValue, oldValue) {
    if (!_.isEqual(newValue, oldValue)) {
      $timeout(function () {
        $scope.renderChart($scope.contextData.chartData);
      }, 0);
    }
  });
  $scope.$watch('contextData.chartData', function (newValue, oldValue) {
    if (!_.isEqual(newValue, oldValue)) {
      $scope.renderChart($scope.contextData.chartData);
    }
  });
};
AdvancedProfileChartController.$inject = ['$scope', '$timeout', 'FormatterService', 'ProfileChartDataProviderService'];
module.exports = AdvancedProfileChartController;